// extracted by mini-css-extract-plugin
module.exports = {"mapContainer":"index_mapContainer_28dVJ","table":"index_table_90CIB","textDivider":"index_textDivider_2AIt4","textDividerContent":"index_textDividerContent_2qbsP"};